<div class="page-buttons">
  <ng-content></ng-content>
</div>
